<template>
  <VModal :showing="showing" container-classes="w-128" @update:showing="$emit('update:showing', $event)">
    <ClientOnly>
      <div class="flex gap-4">
        <div class="icon" :class="variant">
          <ExclamationTriangleIcon class="w-6" :class="variant" />
        </div>

        <div class="content">
          <h2 class="text-lg leading-6 font-medium mr-6"><slot name="title" /></h2>
          <div class="mt-4">
            <p class="text-sm text-gray-700 font-normal leading-5">
              <slot />
            </p>
          </div>
        </div>
      </div>

      <div class="flex flex-row gap-3 mt-4 w-full justify-end">
        <VButton class="_w-42" data-testid="cancel-button" size="md" @click="$emit('update:showing', false)">Cancel</VButton>
        <VButton
          class="_w-42"
          :variant="variant === 'danger' ? 'danger' : 'copper'"
          size="md"
          data-testid="confirmation-button"
          @click="$emit('confirm')"
        >
          {{ confirmationLabel }}
        </VButton>
      </div>
    </ClientOnly>
  </VModal>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'
import { ExclamationTriangleIcon } from '@heroicons/vue/24/outline'

defineProps({
  variant: {
    type: String as PropType<'warning' | 'danger'>,
    default: 'danger',
  },
  confirmationLabel: {
    type: String,
    default: 'Delete',
  },
  showing: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['confirm', 'update:showing'])
</script>

<style lang="stylus" scoped>
.icon
  @apply mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full sm_mx-0 sm_h-10 sm_w-10

  &.danger
    @apply bg-red-100

  &.warning
    @apply bg-orange-50

  & > svg.danger
    @apply text-red-600

  & > svg.warning
    @apply text-yellow-500
</style>
